import { useEffect, useState } from 'react';
import runsService from '../../services/runs';

export type PortalRunMetadata = {
  id?: string;
  pipelineVersion?: string;
  cluster?: string | null;
  triedClusters?: Array<string>;
};

const usePortalRunMetadata = (runId?: string) => {
  const [data, setData] = useState<PortalRunMetadata | null>(null);
  const [loading, setLoading] = useState<boolean>(!!runId);

  useEffect(() => {
    let mounted = true;

    if (!runId) {
      setData(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    (async () => {
      try {
        const result = await runsService.getRun(runId);
        if (mounted) {
          setData(result);
        }
      } catch (error) {
        console.error('Failed to fetch run details', error);
        if (mounted) {
          setData(null);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    })();

    return () => {
      mounted = false;
    };
  }, [runId]);

  return { data, loading };
};

export default usePortalRunMetadata;
